import { YStack } from '@my/ui'
import { BrandTabsBlock } from './brand-tabs.block'
import { BrandTabsHeading } from './brand-tabs-heading'
import { BrandTabs } from 'app/features/brands/components'

export const BrandTabsComponent = (block: BrandTabsBlock) => {
  return (
    <YStack w="100%" gap="$4">
      <BrandTabsHeading heading={block.heading} viewAllLink={block.showViewAllLink} />
      <BrandTabs items={block.brands} imagePriority={block.imagePriority} />
    </YStack>
  )
}
